import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../api/clients';
import { toast } from 'sonner';

export function useShipping() {
  return useQuery({
    queryKey: ['shipping'],
    queryFn: () => api.get('/shipping').then(res => res.data),
    staleTime: 1000 * 60 * 2,
  });
}

export function useShippingItem(id: number) {
  return useQuery({
    queryKey: ['shipping', id],
    queryFn: () => api.get(`/shipping/${id}`).then(res => res.data),
    enabled: !!id && id > 0,
    staleTime: 1000 * 60 * 2,
  });
}

export function useCreateShipping() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => api.post('/shipping', data).then(res => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shipping'] });
      toast.success('Remito creado exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al crear el remito');
    },
  });
}

export function useUpdateShipping() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: any }) =>
      api.put(`/shipping/${id}`, data).then(res => res.data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['shipping'] });
      queryClient.invalidateQueries({ queryKey: ['shipping', id] });
      toast.success('Remito actualizado exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al actualizar el remito');
    },
  });
}

export function useDeleteShipping() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.delete(`/shipping/${id}`).then(res => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shipping'] });
      toast.success('Remito eliminado exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al eliminar el remito');
    },
  });
}

export function useGenerateShippingPDF() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.post(`/shipping/${id}/pdf`).then(res => res.data),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ['shipping'] });
      queryClient.invalidateQueries({ queryKey: ['shipping', id] });
      toast.success('PDF generado exitosamente');
      return data;
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al generar el PDF');
    },
  });
}